import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getRecentNotifications, GetRecentNotificationsRequestOptions } from '~/monolith-api';
import { useIncrementalQuery } from 'pages/_shared';
import { useSiteInfo } from '~/pages/_shared';
import { useRouter } from 'next/router';

export function getRecentNotificationsKey() {
   return ['recent-notifications'] as const;
}

export function useRecentNotifications(options?: GetRecentNotificationsRequestOptions) {
   const router = useRouter();
   const queryClient = useQueryClient();
   const { data: siteInfo } = useSiteInfo();

   useEffect(() => {
      // On route change, check for new notifications
      function handleRouteChange() {
         queryClient.invalidateQueries(getRecentNotificationsKey());
      }

      router.events.on('routeChangeComplete', handleRouteChange);

      // On unmount, remove our event listener
      return () => router.events.off('routeChangeComplete', handleRouteChange);
   }, []);

   return useIncrementalQuery([...getRecentNotificationsKey(), options], async page => {
      let {
         notifications: data,
         hasMore,
         total,
      } = await getRecentNotifications({
         ...options,
         page,
      });
      return { page, data, hasMore, total };
   });
}
